export const functions = [
    { name: "setup(", level: 1 },
    { name: "draw(", level: 1 },
    { name: "preload(", level: 1 },
    { name: "mouseClicked(", level: 1 },
    { name: "mousePressed(", level: 1 },
    { name: "mouseReleased(", level: 1 },
    { name: "mouseMoved(", level: 1 },
    { name: "mouseDragged(", level: 1 },
    { name: "mouseWheel(", level: 2 },
    { name: "keyPressed(", level: 1 },
    { name: "keyReleased(", level: 1 },
    { name: "keyTyped(", level: 1 },
    { name: "touchStarted(", level: 1 },
    { name: "touchMoved(", level: 1 },
    { name: "touchEnded(", level: 1 },
    { name: "deviceMoved(", level: 2 },
    { name: "deviceTurned(", level: 2 },
    { name: "deviceShaken(", level: 2 },
    { name: "windowResized(", level: 1 },
    { name: "createCanvas(", level: 1 },
    { name: "resizeCanvas(", level: 1 },
    { name: "noCanvas(", level: 1 },
    { name: "createGraphics(", level: 2 },
    { name: "blendMode(", level: 2 },
    { name: "alpha(", level: 2 },
    { name: "red(", level: 1 },
    { name: "green(", level: 1 },
    { name: "blue(", level: 1 },
    { name: "hue(", level: 2 },
    { name: "saturation(", level: 2 },
    { name: "brightness(", level: 2 },
    { name: "fill(", level: 1 },
    { name: "noFill(", level: 1 },
    { name: "stroke(", level: 1 },
    { name: "noStroke(", level: 1 },
    { name: "strokeCap(", level: 2 },
    { name: "strokeJoin(", level: 2 },
    { name: "strokeWeight(", level: 1 },
    { name: "cursor(", level: 1 },
    { name: "frameRate(", level: 1 },
    { name: "noLoop(", level: 1 },
    { name: "loop(", level: 1 },
    { name: "push(", level: 2 },
    { name: "pop(", level: 2 },
    { name: "translate(", level: 2 },
    { name: "rotate(", level: 2 },
    { name: "rotateX(", level: 3 },
    { name: "rotateY(", level: 3 },
    { name: "rotateZ(", level: 3 },
    { name: "scale(", level: 2 },
    { name: "applyMatrix(", level: 3 },
    { name: "resetMatrix(", level: 3 },
    { name: "drawSprites(", level: 2 },
    { name: "createSprite(", level: 2 },
    { name: "sprite.addAnimation(", level: 2 },
    { name: "sprite.addImage(", level: 2 },
    { name: "sprite.collide(", level: 2 },
    { name: "group.add(", level: 2 },
    { name: "group.collide(", level: 2 },
    { name: "loadImage(", level: 2 },
    { name: "loadAnimation(", level: 3 },
    { name: "loadSound(", level: 3 },
    { name: "createVideo(", level: 3 },
    { name: "createCapture(", level: 3 },
    { name: "saveCanvas(", level: 2 },
    { name: "saveFrames(", level: 3 },
    { name: "beginShape(", level: 2 },
    { name: "endShape(", level: 2 },
    { name: "vertex(", level: 2 },
    { name: "curveVertex(", level: 3 },
    { name: "bezierVertex(", level: 3 },
    { name: "normal(", level: 3 },
    { name: "ambientLight(", level: 3 },
    { name: "directionalLight(", level: 3 },
    { name: "spotLight(", level: 3 },
    { name: "loadShader(", level: 3 },
    { name: "shader(", level: 3 },
    { name: "resetShader(", level: 3 },
    { name: "createVector(", level: 2 },
    { name: "abs(", level: 1 },
    { name: "ceil(", level: 1 },
    { name: "constrain(", level: 1 },
    { name: "exp(", level: 3 },
    { name: "log(", level: 3 },
    { name: "pow(", level: 2 },
    { name: "random(", level: 2 },
    { name: "sin(", level: 1 },
    { name: "cos(", level: 1 },
    { name: "tan(", level: 2 },
    { name: "noise(", level: 2 },
    { name: "noiseDetail(", level: 3 },
    { name: "filter(", level: 2 },
    { name: "image(", level: 1 },
    { name: "tint(", level: 1 },
    { name: "save(", level: 2 },
    { name: "loadJSON(", level: 3 },
    { name: "httpGet(", level: 3 },
    { name: "httpPost(", level: 3 },
    { name: "clear(", level: 1 },
    { name: "print(", level: 1 },
    { name: "text(", level: 1 },
    { name: "textSize(", level: 1 },
    { name: "loadFont(", level: 2 },
    { name: "background(", level: 1 },
    { name: "arc(", level: 1 },
    { name: "ellipse(", level: 1 },
    { name: "line(", level: 1 },
    { name: "point(", level: 1 },
    { name: "rect(", level: 1 },
    { name: "triangle(", level: 1 }
];